/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedProjectsIndexRouteImport } from './routes/_authed/projects/index'
import { Route as AuthedSettingsApiAccessRouteImport } from './routes/_authed/settings.api-access'
import { Route as AuthedProjectsProjectIdRouteRouteImport } from './routes/_authed/projects/$projectId/route'
import { Route as AuthedProjectsProjectIdIndexRouteImport } from './routes/_authed/projects/$projectId/index'
import { Route as AuthedProjectsProjectIdWorkloadRouteImport } from './routes/_authed/projects/$projectId/workload'
import { Route as AuthedProjectsProjectIdTimelineRouteImport } from './routes/_authed/projects/$projectId/timeline'
import { Route as AuthedProjectsProjectIdTasksRouteImport } from './routes/_authed/projects/$projectId/tasks'
import { Route as AuthedProjectsProjectIdReportRouteImport } from './routes/_authed/projects/$projectId/report'
import { Route as AuthedProjectsProjectIdNotesRouteImport } from './routes/_authed/projects/$projectId/notes'
import { Route as AuthedProjectsProjectIdLeavesRouteImport } from './routes/_authed/projects/$projectId/leaves'
import { Route as AuthedProjectsProjectIdTimelineSummaryRouteImport } from './routes/_authed/projects/$projectId/timeline_.summary'
import { Route as AuthedProjectsProjectIdTasksTaskIdRouteImport } from './routes/_authed/projects/$projectId/tasks_.$taskId'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProjectsIndexRoute = AuthedProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsApiAccessRoute = AuthedSettingsApiAccessRouteImport.update({
  id: '/settings/api-access',
  path: '/settings/api-access',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProjectsProjectIdRouteRoute =
  AuthedProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedProjectsProjectIdIndexRoute =
  AuthedProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdWorkloadRoute =
  AuthedProjectsProjectIdWorkloadRouteImport.update({
    id: '/workload',
    path: '/workload',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdTimelineRoute =
  AuthedProjectsProjectIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdTasksRoute =
  AuthedProjectsProjectIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdReportRoute =
  AuthedProjectsProjectIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdNotesRoute =
  AuthedProjectsProjectIdNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdLeavesRoute =
  AuthedProjectsProjectIdLeavesRouteImport.update({
    id: '/leaves',
    path: '/leaves',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdTimelineSummaryRoute =
  AuthedProjectsProjectIdTimelineSummaryRouteImport.update({
    id: '/timeline_/summary',
    path: '/timeline/summary',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)
const AuthedProjectsProjectIdTasksTaskIdRoute =
  AuthedProjectsProjectIdTasksTaskIdRouteImport.update({
    id: '/tasks_/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthedProjectsProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/profile': typeof AuthedProfileRoute
  '/projects/$projectId': typeof AuthedProjectsProjectIdRouteRouteWithChildren
  '/settings/api-access': typeof AuthedSettingsApiAccessRoute
  '/projects/': typeof AuthedProjectsIndexRoute
  '/projects/$projectId/leaves': typeof AuthedProjectsProjectIdLeavesRoute
  '/projects/$projectId/notes': typeof AuthedProjectsProjectIdNotesRoute
  '/projects/$projectId/report': typeof AuthedProjectsProjectIdReportRoute
  '/projects/$projectId/tasks': typeof AuthedProjectsProjectIdTasksRoute
  '/projects/$projectId/timeline': typeof AuthedProjectsProjectIdTimelineRoute
  '/projects/$projectId/workload': typeof AuthedProjectsProjectIdWorkloadRoute
  '/projects/$projectId/': typeof AuthedProjectsProjectIdIndexRoute
  '/projects/$projectId/tasks/$taskId': typeof AuthedProjectsProjectIdTasksTaskIdRoute
  '/projects/$projectId/timeline/summary': typeof AuthedProjectsProjectIdTimelineSummaryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/profile': typeof AuthedProfileRoute
  '/settings/api-access': typeof AuthedSettingsApiAccessRoute
  '/projects': typeof AuthedProjectsIndexRoute
  '/projects/$projectId/leaves': typeof AuthedProjectsProjectIdLeavesRoute
  '/projects/$projectId/notes': typeof AuthedProjectsProjectIdNotesRoute
  '/projects/$projectId/report': typeof AuthedProjectsProjectIdReportRoute
  '/projects/$projectId/tasks': typeof AuthedProjectsProjectIdTasksRoute
  '/projects/$projectId/timeline': typeof AuthedProjectsProjectIdTimelineRoute
  '/projects/$projectId/workload': typeof AuthedProjectsProjectIdWorkloadRoute
  '/projects/$projectId': typeof AuthedProjectsProjectIdIndexRoute
  '/projects/$projectId/tasks/$taskId': typeof AuthedProjectsProjectIdTasksTaskIdRoute
  '/projects/$projectId/timeline/summary': typeof AuthedProjectsProjectIdTimelineSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/projects/$projectId': typeof AuthedProjectsProjectIdRouteRouteWithChildren
  '/_authed/settings/api-access': typeof AuthedSettingsApiAccessRoute
  '/_authed/projects/': typeof AuthedProjectsIndexRoute
  '/_authed/projects/$projectId/leaves': typeof AuthedProjectsProjectIdLeavesRoute
  '/_authed/projects/$projectId/notes': typeof AuthedProjectsProjectIdNotesRoute
  '/_authed/projects/$projectId/report': typeof AuthedProjectsProjectIdReportRoute
  '/_authed/projects/$projectId/tasks': typeof AuthedProjectsProjectIdTasksRoute
  '/_authed/projects/$projectId/timeline': typeof AuthedProjectsProjectIdTimelineRoute
  '/_authed/projects/$projectId/workload': typeof AuthedProjectsProjectIdWorkloadRoute
  '/_authed/projects/$projectId/': typeof AuthedProjectsProjectIdIndexRoute
  '/_authed/projects/$projectId/tasks_/$taskId': typeof AuthedProjectsProjectIdTasksTaskIdRoute
  '/_authed/projects/$projectId/timeline_/summary': typeof AuthedProjectsProjectIdTimelineSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/profile'
    | '/projects/$projectId'
    | '/settings/api-access'
    | '/projects/'
    | '/projects/$projectId/leaves'
    | '/projects/$projectId/notes'
    | '/projects/$projectId/report'
    | '/projects/$projectId/tasks'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/workload'
    | '/projects/$projectId/'
    | '/projects/$projectId/tasks/$taskId'
    | '/projects/$projectId/timeline/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/profile'
    | '/settings/api-access'
    | '/projects'
    | '/projects/$projectId/leaves'
    | '/projects/$projectId/notes'
    | '/projects/$projectId/report'
    | '/projects/$projectId/tasks'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/workload'
    | '/projects/$projectId'
    | '/projects/$projectId/tasks/$taskId'
    | '/projects/$projectId/timeline/summary'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/sign-in'
    | '/_authed/profile'
    | '/_authed/projects/$projectId'
    | '/_authed/settings/api-access'
    | '/_authed/projects/'
    | '/_authed/projects/$projectId/leaves'
    | '/_authed/projects/$projectId/notes'
    | '/_authed/projects/$projectId/report'
    | '/_authed/projects/$projectId/tasks'
    | '/_authed/projects/$projectId/timeline'
    | '/_authed/projects/$projectId/workload'
    | '/_authed/projects/$projectId/'
    | '/_authed/projects/$projectId/tasks_/$taskId'
    | '/_authed/projects/$projectId/timeline_/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/projects/': {
      id: '/_authed/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthedProjectsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/api-access': {
      id: '/_authed/settings/api-access'
      path: '/settings/api-access'
      fullPath: '/settings/api-access'
      preLoaderRoute: typeof AuthedSettingsApiAccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/projects/$projectId': {
      id: '/_authed/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthedProjectsProjectIdRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/projects/$projectId/': {
      id: '/_authed/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/workload': {
      id: '/_authed/projects/$projectId/workload'
      path: '/workload'
      fullPath: '/projects/$projectId/workload'
      preLoaderRoute: typeof AuthedProjectsProjectIdWorkloadRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/timeline': {
      id: '/_authed/projects/$projectId/timeline'
      path: '/timeline'
      fullPath: '/projects/$projectId/timeline'
      preLoaderRoute: typeof AuthedProjectsProjectIdTimelineRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/tasks': {
      id: '/_authed/projects/$projectId/tasks'
      path: '/tasks'
      fullPath: '/projects/$projectId/tasks'
      preLoaderRoute: typeof AuthedProjectsProjectIdTasksRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/report': {
      id: '/_authed/projects/$projectId/report'
      path: '/report'
      fullPath: '/projects/$projectId/report'
      preLoaderRoute: typeof AuthedProjectsProjectIdReportRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/notes': {
      id: '/_authed/projects/$projectId/notes'
      path: '/notes'
      fullPath: '/projects/$projectId/notes'
      preLoaderRoute: typeof AuthedProjectsProjectIdNotesRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/leaves': {
      id: '/_authed/projects/$projectId/leaves'
      path: '/leaves'
      fullPath: '/projects/$projectId/leaves'
      preLoaderRoute: typeof AuthedProjectsProjectIdLeavesRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/timeline_/summary': {
      id: '/_authed/projects/$projectId/timeline_/summary'
      path: '/timeline/summary'
      fullPath: '/projects/$projectId/timeline/summary'
      preLoaderRoute: typeof AuthedProjectsProjectIdTimelineSummaryRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
    '/_authed/projects/$projectId/tasks_/$taskId': {
      id: '/_authed/projects/$projectId/tasks_/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/projects/$projectId/tasks/$taskId'
      preLoaderRoute: typeof AuthedProjectsProjectIdTasksTaskIdRouteImport
      parentRoute: typeof AuthedProjectsProjectIdRouteRoute
    }
  }
}

interface AuthedProjectsProjectIdRouteRouteChildren {
  AuthedProjectsProjectIdLeavesRoute: typeof AuthedProjectsProjectIdLeavesRoute
  AuthedProjectsProjectIdNotesRoute: typeof AuthedProjectsProjectIdNotesRoute
  AuthedProjectsProjectIdReportRoute: typeof AuthedProjectsProjectIdReportRoute
  AuthedProjectsProjectIdTasksRoute: typeof AuthedProjectsProjectIdTasksRoute
  AuthedProjectsProjectIdTimelineRoute: typeof AuthedProjectsProjectIdTimelineRoute
  AuthedProjectsProjectIdWorkloadRoute: typeof AuthedProjectsProjectIdWorkloadRoute
  AuthedProjectsProjectIdIndexRoute: typeof AuthedProjectsProjectIdIndexRoute
  AuthedProjectsProjectIdTasksTaskIdRoute: typeof AuthedProjectsProjectIdTasksTaskIdRoute
  AuthedProjectsProjectIdTimelineSummaryRoute: typeof AuthedProjectsProjectIdTimelineSummaryRoute
}

const AuthedProjectsProjectIdRouteRouteChildren: AuthedProjectsProjectIdRouteRouteChildren =
  {
    AuthedProjectsProjectIdLeavesRoute: AuthedProjectsProjectIdLeavesRoute,
    AuthedProjectsProjectIdNotesRoute: AuthedProjectsProjectIdNotesRoute,
    AuthedProjectsProjectIdReportRoute: AuthedProjectsProjectIdReportRoute,
    AuthedProjectsProjectIdTasksRoute: AuthedProjectsProjectIdTasksRoute,
    AuthedProjectsProjectIdTimelineRoute: AuthedProjectsProjectIdTimelineRoute,
    AuthedProjectsProjectIdWorkloadRoute: AuthedProjectsProjectIdWorkloadRoute,
    AuthedProjectsProjectIdIndexRoute: AuthedProjectsProjectIdIndexRoute,
    AuthedProjectsProjectIdTasksTaskIdRoute:
      AuthedProjectsProjectIdTasksTaskIdRoute,
    AuthedProjectsProjectIdTimelineSummaryRoute:
      AuthedProjectsProjectIdTimelineSummaryRoute,
  }

const AuthedProjectsProjectIdRouteRouteWithChildren =
  AuthedProjectsProjectIdRouteRoute._addFileChildren(
    AuthedProjectsProjectIdRouteRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedProjectsProjectIdRouteRoute: typeof AuthedProjectsProjectIdRouteRouteWithChildren
  AuthedSettingsApiAccessRoute: typeof AuthedSettingsApiAccessRoute
  AuthedProjectsIndexRoute: typeof AuthedProjectsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedProjectsProjectIdRouteRoute:
    AuthedProjectsProjectIdRouteRouteWithChildren,
  AuthedSettingsApiAccessRoute: AuthedSettingsApiAccessRoute,
  AuthedProjectsIndexRoute: AuthedProjectsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
